
<!--导入excel文件-->
<template>
  <div>
    <!--导入文件-->
    <el-upload
      class="upload-demo"
      action=""
      :on-change="handleChange"
      :on-remove="handleRemove"
      :file-list="fileListUpload"
      :limit="limitUpload"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
      :auto-upload="true">
      <el-button size="medium" type="primary" class="operator-btn" style="width: 180px; margin-right: 0px;">{{title}}</el-button>
    </el-upload>
  </div>
</template>
<style>

</style>
<script>



  export default {
    name: 'ExceptExcel',
    props: {
      title:String

    },
    data() {
      return {
        fileTemp:"",
        fileListUpload:[],
        limitUpload:1,
      }
    },
    created(){

    },

    methods:{

      handleChange(file, fileList){
        this.fileTemp = file.raw;
        if(this.fileTemp){
          this.importfxx(this.fileTemp)
          return;
          if((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || (this.fileTemp.type == 'application/vnd.ms-excel')){
            this.importfxx(this.fileTemp)
          } else {
            this.$message({
              type:'warning',
              message:'附件格式错误，请删除后重新上传！'
            })
          }
        } else {
          this.$message({
            type:'warning',
            message:'请上传附件！'
          })
        }

      },

      handleRemove(file,fileList){
        this.fileTemp = null
      },

      importfxx(obj) {
        let _this = this;
        // 通过DOM取文件数据
        this.file = obj
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var reader = new FileReader();
        //if (!FileReader.prototype.readAsBinaryString) {
        FileReader.prototype.readAsBinaryString = function(f) {
          var binary = "";
          var rABS = false; //是否将文件读取为二进制字符串
          var pt = this;
          var wb; //读取完成的数据
          var outdata;
          var reader = new FileReader();
          reader.onload = function(e) {
            var bytes = new Uint8Array(reader.result);
            var length = bytes.byteLength;
            for(var i = 0; i < length; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            var XLSX = require('xlsx');
            if(rABS) {
              wb = XLSX.read(btoa(fixdata(binary)), { //手动转化
                type: 'base64'
              });
            } else {
              wb = XLSX.read(binary, {
                type: 'binary'
              });
            }
            outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西


            this.da = [...outdata];
            let  exDa = this.da;
            _this.onExceptArray(exDa);
          }
          reader.readAsArrayBuffer(f);
        }

        if(rABS) {
          reader.readAsArrayBuffer(f);
        } else {
          reader.readAsBinaryString(f);
        }
      },

      onExceptArray(arr){
        this.$emit('onExceptArray',arr);
      }
    },


  }
</script>



// WEBPACK FOOTER //
// src/components/excel/ExceptExcel.vue